/* ============================================================
   Petronella's — horizontal rail slider (mood rail + booksellers'
   shelf + gift sets). Arrow buttons scroll the overflow rail; they
   disable at the ends. Mark up:
     <div class="fn-slider" data-fn-slider>
       <button class="fn-slider__btn fn-slider__btn--prev">…</button>
       <div class="fn-shelf--books" data-rail>…cards…</div>
       <button class="fn-slider__btn fn-slider__btn--next">…</button>
     </div>
   ============================================================ */
(function () {
  "use strict";

  function initRail(slider) {
    var rail = slider.querySelector("[data-rail]");
    var prev = slider.querySelector(".fn-slider__btn--prev");
    var next = slider.querySelector(".fn-slider__btn--next");
    if (!rail || (!prev && !next)) return;

    function step() {
      var card = rail.firstElementChild;
      var w = card ? card.getBoundingClientRect().width + 24 : rail.clientWidth * 0.8;
      return w * 2;
    }
    function update() {
      var max = rail.scrollWidth - rail.clientWidth - 2;
      if (prev) prev.disabled = rail.scrollLeft <= 2;
      if (next) next.disabled = rail.scrollLeft >= max;
    }
    if (prev) prev.addEventListener("click", function () { rail.scrollBy({ left: -step(), behavior: "smooth" }); });
    if (next) next.addEventListener("click", function () { rail.scrollBy({ left: step(), behavior: "smooth" }); });
    rail.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
    update();
  }

  function init() { document.querySelectorAll("[data-fn-slider]").forEach(initRail); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();
